"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Marquee = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _bricksTheme = _interopRequireDefault(require("@titelmedia/bricks-theme"));
var _bricksUtils = require("@titelmedia/bricks-utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const MarqueeItem = ({
  image,
  svg,
  desktopHeight,
  mobileHeight,
  text,
  fontWeight,
  fontColor
}) => {
  const renderSvg = () => {
    return _react.default.createElement(_styles.ImageSvg, {
      src: svg.url,
      desktopHeight: desktopHeight,
      mobileHeight: mobileHeight
    });
  };
  const renderImgText = () => {
    return _react.default.createElement(_styles.Image, {
      src: image.src,
      srcSet: image.srcSet,
      alt: image.src,
      bold: fontWeight === 'bold',
      text: text !== ''
    });
  };
  return _react.default.createElement(_styles.StyledMarqueeItem, {
    className: "item",
    desktopHeight: desktopHeight,
    mobileHeight: mobileHeight
  }, _react.default.createElement(_styles.MarqueeContainer, null, svg && renderSvg(), image && renderImgText(), text && _react.default.createElement(_styles.Text, {
    bold: fontWeight === 'bold',
    fontColor: fontColor?.hex || fontColor
  }, text)));
};
const Marquee = ({
  images,
  text,
  svg,
  fontWeight,
  fontColor,
  backgroundColor,
  desktopHeight,
  mobileHeight,
  direction,
  marqueeDuration,
  triggerScrub
}) => {
  const containerRef = (0, _react.useRef)(null);
  const wrapperRef = (0, _react.useRef)(null);
  const length = images?.length > 0 ? images.length : 7;
  (0, _react.useEffect)(() => {
    setTimeout(() => {
      const items = wrapperRef.current.querySelectorAll('.item');
      const width = items[0].offsetWidth;
      const dir = direction === 'left' ? '-=' : '+=';
      const duration = marqueeDuration ? marqueeDuration : 30;
      const total = width * length;
      let mod = _bricksUtils.gsap.utils.wrap(0, total);
      _bricksUtils.gsap.set(items, {
        x: i => i * width
      });
      _bricksUtils.gsap.set(containerRef.current, {
        x: `-=${width}`
      });
      if (triggerScrub) {
        _bricksUtils.gsap.to(items, {
          ease: 'none',
          duration: duration,
          x: `${dir + total}`,
          modifiers: {
            x: x => `${mod(parseFloat(x))}px`
          },
          scrollTrigger: {
            trigger: wrapperRef.current,
            start: '5% bottom',
            end: 'max',
            invalidateOnRefresh: true,
            scrub: true
          }
        });
      } else {
        _bricksUtils.gsap.to(items, {
          ease: 'none',
          duration: duration,
          x: `${dir + total}`,
          modifiers: {
            x: x => `${mod(parseFloat(x))}px`
          },
          repeat: -1
        });
      }
    }, 250);
  }, []);
  return _react.default.createElement(_styles.Wrapper, {
    ref: wrapperRef,
    backgroundColor: backgroundColor?.hex || backgroundColor
  }, _react.default.createElement(_bricksTheme.default, null), _react.default.createElement(_styles.Container, {
    ref: containerRef,
    desktopHeight: desktopHeight,
    mobileHeight: mobileHeight
  }, images?.length > 0 && images.map((image, i) => _react.default.createElement(MarqueeItem, {
    image: image,
    text: text,
    fontWeight: fontWeight,
    fontColor: fontColor,
    desktopHeight: desktopHeight,
    mobileHeight: mobileHeight,
    key: `marquee-item--${i}`
  })), images?.length === 0 && text && Array(length).fill(0).map((item, i) => _react.default.createElement(MarqueeItem, {
    text: text,
    desktopHeight: desktopHeight,
    mobileHeight: mobileHeight,
    key: `marquee-item--${i}`
  })), svg && Array(length).fill(0).map((item, i) => _react.default.createElement(MarqueeItem, {
    svg: svg,
    desktopHeight: desktopHeight,
    mobileHeight: mobileHeight,
    key: `marquee-item--${i}`
  }))));
};
exports.Marquee = Marquee;
//# sourceMappingURL=index.js.map